import { render, staticRenderFns } from "./CreateZIPTask.vue?vue&type=template&id=188ad454&"
import script from "./CreateZIPTask.vue?vue&type=script&lang=js&"
export * from "./CreateZIPTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports